import type { MouseEvent } from "react";
import { NavLink } from "react-router-dom";
import { MainNavItem } from "@theorgchartdev/storybook";
import type { MainNavItemOption } from "./useMainNavItems";
import { NavItemUpgradeBadge } from "./NavItemUpgradeBadge";

type MainNavIconProps = {
  item: MainNavItemOption;
};

const MainNavIcon = ({ item }: MainNavIconProps) => {
  const label = (
    <MainNavItem
      label={item.name}
      icon={item.icon}
      checked={item.showUpgrade ? false : item.checked}
      disabled={item.disabled}
      dataTestId={
        item.showUpgrade ? `main-nav-upgrade-link-${item.name}` : `main-nav-link-${item.name}`
      }
      className={item.className}
      tabIndex={-1}
    />
  );

  if (item.showUpgrade) {
    return <NavItemUpgradeBadge item={item}>{label}</NavItemUpgradeBadge>;
  }

  return (
    <NavLink
      to={item.route}
      className={"unstyledLink ocn-focus-ring"}
      onClick={item.onClick ? (e: MouseEvent) => item.onClick?.(e) : undefined}
    >
      {label}
    </NavLink>
  );
};

export default MainNavIcon;
